'use strict';

const { COLORS } = require('../config/constants');
const { roundedRectPath, drawText, drawLock } = require('./draw');

class Button {
  constructor(options) {
    const config = options || {};
    this.x = config.x || 0;
    this.y = config.y || 0;
    this.width = config.width || 240;
    this.height = config.height || 88;
    this.label = config.label || '';
    this.onTap = config.onTap || function noop() {};
    this.disabled = Boolean(config.disabled);
    this.variant = config.variant || 'primary';
    this.fontSize = config.fontSize || 32;
  }

  contains(x, y) {
    return !this.disabled && x >= this.x && x <= this.x + this.width &&
      y >= this.y && y <= this.y + this.height;
  }

  tap() {
    if (!this.disabled) this.onTap();
  }

  draw(ctx) {
    ctx.save();
    roundedRectPath(ctx, this.x, this.y, this.width, this.height, 22);
    if (this.disabled) {
      ctx.fillStyle = 'rgba(31, 49, 82, 0.68)';
      ctx.strokeStyle = 'rgba(145, 164, 201, 0.26)';
    } else if (this.variant === 'secondary') {
      ctx.fillStyle = 'rgba(18, 43, 82, 0.88)';
      ctx.strokeStyle = COLORS.blue;
    } else if (this.variant === 'danger') {
      ctx.fillStyle = 'rgba(105, 25, 47, 0.88)';
      ctx.strokeStyle = COLORS.danger;
    } else {
      const gradient = ctx.createLinearGradient(this.x, this.y, this.x + this.width, this.y);
      gradient.addColorStop(0, '#167bc8');
      gradient.addColorStop(1, '#7157d9');
      ctx.fillStyle = gradient;
      ctx.strokeStyle = COLORS.cyan;
    }
    ctx.lineWidth = 2;
    ctx.fill();
    ctx.stroke();
    ctx.restore();

    if (this.disabled) {
      drawLock(ctx, this.x + this.width / 2, this.y + this.height / 2, 0.75);
    } else {
      drawText(
        ctx,
        this.label,
        this.x + this.width / 2,
        this.y + this.height / 2,
        this.fontSize,
        COLORS.text,
        'center',
        'bold'
      );
    }
  }
}

module.exports = Button;

